import { render } from "./UpdateQwilrDefinitionField.vue?vue&type=template&id=2ed3c2c2&scoped=true"
import script from "./UpdateQwilrDefinitionField.vue?vue&type=script&lang=js"
export * from "./UpdateQwilrDefinitionField.vue?vue&type=script&lang=js"

import "./UpdateQwilrDefinitionField.vue?vue&type=style&index=0&id=2ed3c2c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed3c2c2"]])

export default __exports__